import React, { FunctionComponent } from "react";

import { TemplateLayoutItem, Text } from "@multiweb/reactComponents";
import { IUserParticipantInformation } from "@multiweb/reactCore/workflow";
import { IDataAttribute, RecordType } from "@multiweb/types/react";
import { RoleUserRow } from "../../../components/RoleUserRow";
import { EMPTY_PARTICIPANT_TEXT_VALUE } from "../../../constants";
import { ROLE_USERS_ATTRIBUTE_CLASS_NAME as classNames } from "./constants";
import { RoleUsersAttributeProps } from "./RoleUsersAttribute";

export type RoleUsersAttributeComponentProps = RoleUsersAttributeProps & {
    /**
     * Záznam, ze kterého získáme potřebné data.
     */
    record?: RecordType;
    /**
     * Defaultní hodnota pro zobrazení při prázdném názvu.
     */
    emptyValue?: string;
};

export const RoleUsersAttributeComponent: FunctionComponent<RoleUsersAttributeComponentProps> = ({
    record,
    attributeName,
    dataSourceKey,
    recordId,
    emptyValue = EMPTY_PARTICIPANT_TEXT_VALUE,
}) => {
    const users: IDataAttribute<IUserParticipantInformation[]> | undefined = record?.[attributeName];

    if (!record || users?.value?.length === 0) {
        return null;
    }

    const components = users?.value?.map(({ id, name, personname }) => {
        return (
            <RoleUserRow
                key={id.value}
                id={id.value.toString()}
                {...{ dataSourceKey, recordId, attributeName }}
            >
                <TemplateLayoutItem content={<Text value={personname?.value ?? emptyValue} />} />
                <TemplateLayoutItem content={<Text value={name.value ?? emptyValue} />} />
            </RoleUserRow>
        );
    });

    return (
        <div className={classNames()}>
            {components}
        </div>
    );
};
